import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddFormationState {
  title: string;
  description: string;
  price: string;
  image: any;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: AddFormationState = {
  description: "",
  price: "",
  title: "",
  image: "",
  loading: true,
  error: "",
};

export const addFormationSlice = createSlice({
  name: "addFormation",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setPrice: (state, action: PayloadAction<string>) => {
      state.price = action.payload;
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    setImage: (state, action: PayloadAction<any>) => {
      state.image = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setTitle,
  setDescription,
  setImage,
  setPrice,
  setError,
  setLoading,
} = addFormationSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddFormationData = (state: RootState) => state.addFormation;
export default addFormationSlice.reducer;
